// Aurora 배경 효과 컴포넌트
// Aceternity UI 스타일의 오로라 그라데이션 애니메이션

"use client";

import { cn } from "../../lib/utils";
import React from "react";

interface AuroraBackgroundProps {
    children: React.ReactNode;
    className?: string;
    showRadialGradient?: boolean;
    theme?: "dark" | "light";
}

export const AuroraBackground = ({
    children,
    className,
    showRadialGradient = true,
    theme = "dark",
}: AuroraBackgroundProps) => {
    return (
        <div
            className={cn(
                "relative min-h-screen overflow-hidden transition-colors duration-1000",
                theme === "dark"
                    ? "bg-gradient-to-b from-black via-purple-950/20 to-black"
                    : "bg-gradient-to-b from-blue-50 via-violet-50 to-purple-50",
                className
            )}
        >
            {/* Aurora 그라데이션 효과 */}
            <div className="absolute inset-0 overflow-hidden">
                <div
                    className={cn(
                        `
            [--white-gradient:repeating-linear-gradient(100deg,var(--white)_0%,var(--white)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--white)_16%)]
            [--dark-gradient:repeating-linear-gradient(100deg,var(--black)_0%,var(--black)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--black)_16%)]
            [--aurora:repeating-linear-gradient(100deg,var(--blue-500)_10%,var(--indigo-300)_15%,var(--blue-300)_20%,var(--violet-200)_25%,var(--blue-400)_30%)]
            [background-image:var(--white-gradient),var(--aurora)]
            dark:[background-image:var(--dark-gradient),var(--aurora)]
            [background-size:300%,_200%]
            [background-position:50%_50%,50%_50%]
            filter blur-[10px] invert dark:invert-0
            after:content-[""] after:absolute after:inset-0 after:[background-image:var(--white-gradient),var(--aurora)]
            after:dark:[background-image:var(--dark-gradient),var(--aurora)]
            after:[background-size:200%,_100%]
            after:animate-aurora after:[background-attachment:fixed] after:mix-blend-difference
            pointer-events-none
            absolute -inset-[10px] opacity-50 will-change-transform`,
                        "animate-aurora"
                    )}
                ></div>
            </div>

            {/* Radial gradient overlay - 중앙을 밝게 */}
            {showRadialGradient && (
                <div
                    className={cn(
                        "absolute inset-0 transition-opacity duration-1000",
                        theme === "dark"
                            ? "bg-[radial-gradient(ellipse_at_center,transparent_0%,black_70%)]"
                            : "bg-[radial-gradient(ellipse_at_center,transparent_0%,white_70%)]"
                    )}
                />
            )}

            {/* Content */}
            <div className="relative z-10">{children}</div>
        </div>
    );
};
